package top.wcpe.allincore.ui.runtime.element

import kotlin.jvm.JvmStatic

/**
 * 下拉选项。
 *
 * 本身不参与布局 / 命中，仅作为 [Dropdown] 展开面板的数据载体——Dropdown 自绘选项条目并自管点击命中。
 * value 默认与 id 相同；label 默认回退到 value()，当需要「显示文本」与「提交值」分离时显式设置。
 */
class DropdownOption private constructor() : UIElement<DropdownOption>() {

    private var valueText: String = ""
    private var labelText: String = ""

    protected override fun self(): DropdownOption = this

    /** 设置提交值（null 视作空串），返回自身以便链式调用。 */
    fun value(v: String?): DropdownOption {
        valueText = v ?: ""
        return this
    }

    /** 取提交值；未显式设置时回退到 id，便于 DSL 直接 `option "easy" {}` 写法。 */
    fun value(): String {
        val currentId = idField
        return if (valueText.isEmpty() && currentId != null) currentId else valueText
    }

    /** 设置显示文本（null 视作空串），返回自身以便链式调用。 */
    fun label(v: String?): DropdownOption {
        labelText = v ?: ""
        return this
    }

    /** 获取显示文本：label 非空时使用 label，否则回退到 value()。 */
    fun label(): String = labelText.ifEmpty { value() }

    companion object {
        /** 创建一个下拉选项。 */
        @JvmStatic
        fun create(): DropdownOption = DropdownOption()
    }
}
